import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import { useContext } from 'react';
import AuthContext from '../AuthProvider/AuthContext';
/**
 * Vraci `Promise`, ktera je fullfill po prihlaseni uzivate.
 */

export default function useOnAuthenticated() {
  var ctx = useContext(AuthContext);
  return ctx ? ctx.onAuthenticated : Promise.resolve();
}